import { Alert, Anchor, Button, Stack, Text, Title } from "@mantine/core";

import { AuthPageFrame } from "./AuthPageFrame.js";

export function LoginPage({
  message,
}: {
  readonly message?: string;
}) {
  return (
    <AuthPageFrame>
      <Stack gap="md">
        <Title order={1}>Video analytics</Title>
        {message ? <Alert color="red" role="alert">{message}</Alert> : null}
        <Button component="a" href="/api/auth/oidc/browser-start">
          Continue with Google
        </Button>
        <Text c="dimmed" size="sm">
          <Anchor href="/login/admin">Admin</Anchor>
        </Text>
      </Stack>
    </AuthPageFrame>
  );
}
